import { render, staticRenderFns } from "./carouselPhone.vue?vue&type=template&id=42b0eafa&scoped=true"
import script from "./carouselPhone.vue?vue&type=script&lang=js"
export * from "./carouselPhone.vue?vue&type=script&lang=js"
import style0 from "./carouselPhone.vue?vue&type=style&index=0&id=42b0eafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b0eafa",
  null
  
)

export default component.exports